import { UserEntity } from '@data/utils/types';
import { capitalize } from '@app/utils';

export const getUserInitials = (user: UserEntity) => {
  // Filtered rather than both taken: a template literal prints a missing name as the word "undefined".
  const initials = [user?.firstName, user?.lastName]
    .filter((name): name is string => Boolean(name))
    .map(name => name.charAt(0))
    .join('');

  return capitalize(initials || user.email.charAt(0));
};
